const TermsAndConditions = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "32px 16px",
            }}
        >
            <div
                style={{
                    background: "#ffffff",
                    width: "100%",
                    maxWidth: "794px",
                    minHeight: "1123px",
                    padding: "56px 64px",
                    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
                    borderRadius: "4px",
                    boxSizing: "border-box",
                    lineHeight: 1.5,
                    fontSize: "14px",
                    textAlign: "justify",
                }}
            >
        <h1 style={{ color: "#4f81bd" }}>Terms &amp; Conditions</h1>
                <p>
                    <b>CUbits, Inc.&nbsp;| cubits.ai</b>{" "}
                </p>
                <p>
                    <b>
                        Version 3 | Effective Date: June 1, 2026 | Last Updated: May 2026
                    </b>{" "}
                </p>
                <hr />
                <p></p>
                <p>
                    <b>
                        Please read these Terms and Conditions carefully before using
                        CUbits.
                    </b>{" "}
                    &nbsp;By accessing or using the CUbits platform at cubits.ai, you
                    agree to be bound by these Terms. If you do not agree, please do not
                    use our services. These Terms apply to all visitors, registered users,
                    educators, and content creators on the platform.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Acceptance of Terms</h1>
                <p>
                    These Terms and Conditions (&ldquo;
                    <b>Terms</b> &rdquo;) constitute a legally binding agreement between
                    you (&ldquo;
                    <b>User</b> ,&rdquo; &ldquo;
                    <b>you</b> ,&rdquo; or &ldquo;
                    <b>your</b> &rdquo;) and CUbits, Inc.&nbsp;(&ldquo;
                    <b>CUbits</b> ,&rdquo; &ldquo;
                    <b>we</b> ,&rdquo; &ldquo;
                    <b>us</b> ,&rdquo; or &ldquo;
                    <b>our</b> &rdquo;), the company behind the CUbits platform,
                    incorporated and operating from 100 Overlook Center, 2nd Floor,
                    Princeton, NJ.
                </p>
                <p>
                    By creating an account, accessing course content, using AI-powered
                    features, or otherwise interacting with any part of the CUbits
                    service, you acknowledge that you have read, understood, and agree to
                    be bound by these Terms as well as our Privacy Policy, which is
                    incorporated herein by reference.
                </p>
                <p>
                    We reserve the right to modify these Terms at any time. Continued use
                    of the platform after changes are posted constitutes your acceptance
                    of the revised Terms.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Platform Description</h1>
                <p>
                    CUbits is an AI-powered video learning platform founded by faculty and
                    students from Princeton University. The platform provides access to
                    curated educational video content in computer science, technology, and
                    related fields, sourced from top universities and expert instructors.
                </p>
                <p>Our core services include:</p>
                <ul>
                    <li>Deeply searchable, curated educational video libraries</li>
                    <li>
                        AI-driven video curation and personalization technology (protected
                        by patents granted in 2021)
                    </li>
                    <li>
                        cuGPT &mdash; our integrated generative AI tool (customized for your
                        course) for video summaries, on-demand questions, and contextual
                        Q&amp;A
                    </li>
                    <li>
                        Interactive learning objects converted from standard video content
                    </li>
                    <li>Creator tools for educators and content contributors</li>
                </ul>
                <p>
                    CUbits differentiates itself from general video platforms by providing
                    a highly curated, searchable, and personalized learning experience
                    backed by patented AI curation technology.
                </p>
        <h1 style={{ color: "#4f81bd" }}>User Accounts</h1>
                <p>
                    To access most features of CUbits, you must register for an account.
                    You agree to provide accurate, complete, and up-to-date information
                    during registration and to maintain the security of your account
                    credentials.
                </p>
                <p>You are responsible for:</p>
                <ul>
                    <li>All activity that occurs under your account</li>
                    <li>Maintaining the confidentiality of your password</li>
                    <li>
                        Notifying us immediately of any unauthorized use of your account
                    </li>
                    <li>
                        Ensuring your account information remains current and accurate
                    </li>
                </ul>
                <p>
                    CUbits reserves the right to terminate or suspend accounts that
                    provide false information, violate these Terms, or engage in activity
                    harmful to the platform or its users. Accounts are personal and
                    non-transferable unless you are an organization purchasing
                    institutional access.
                </p>
                <p>
                    <i>
                        Age Requirement: CUbits is intended for users aged 18 and older. If
                        you are under 18, please do not use this platform.
                    </i>{" "}
                </p>
        <h1 style={{ color: "#4f81bd" }}>Subscriptions &amp; Payments</h1>
                <p>
                    CUbits offers both free and paid subscription tiers. Paid plans
                    provide enhanced access to premium video content, advanced AI
                    features, and additional learning tools. Current pricing and plan
                    details are available on the CUbits pricing page at cubits.ai.
                </p>
                <p>By subscribing to a paid plan, you agree to the following:</p>
                <ul>
                    <li>
                        Subscription fees are billed as you purchase a subscription to a
                        module or course
                    </li>
                    <li>
                        Payments are processed securely through our third-party payment
                        processor, Stripe
                    </li>
                    <li>
                        We reserve the right to change module or course subscription pricing
                        with reasonable advance notice
                    </li>
                    <li>
                        You are responsible for any applicable taxes in your jurisdiction
                    </li>
                </ul>
                <p>
                    <i>
                        Refund Policy: Refund requests may be submitted within 7 days of a
                        new subscription purchase or renewal. Refunds are evaluated on a
                        case-by-case basis. We do not offer refunds for partial subscription
                        periods or for content already accessed. Please contact
                        support@cubits.ai for refund inquiries.
                    </i>{" "}
                </p>
                <p>
                    CUbits also offers institutional and educational pricing for
                    universities, schools, and corporate training programs. Please contact
                    us directly for bulk licensing arrangements.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Acceptable Use</h1>
                <p>
                    You agree to use CUbits solely for lawful, personal educational
                    purposes. The following activities are strictly prohibited:
                </p>
                <ul>
                    <li>
                        Downloading, copying, reproducing, or redistributing any video
                        content without written authorization
                    </li>
                    <li>
                        Sharing account credentials to provide unauthorized access to paid
                        content
                    </li>
                    <li>
                        Using automated tools, bots, or scrapers to extract content or data
                        from the platform
                    </li>
                    <li>
                        Attempting to circumvent any access controls, digital rights
                        management, or security measures
                    </li>
                    <li>
                        Uploading or transmitting content that is infringing, defamatory,
                        obscene, or otherwise unlawful
                    </li>
                    <li>
                        Impersonating any instructor, creator, CUbits employee, or other
                        user
                    </li>
                    <li>
                        Using the platform to advertise, solicit, or conduct commercial
                        activities without prior written consent
                    </li>
                    <li>
                        Interfering with or disrupting the integrity or performance of the
                        platform
                    </li>
                </ul>
                <p>
                    <b>
                        Violations of this policy may result in immediate account
                        suspension, termination of access without refund, and potential
                        legal action.
                    </b>{" "}
                </p>
        <h1 style={{ color: "#4f81bd" }}>Creator Terms</h1>
        <h2 style={{ color: "#4f81bd" }}>Source Material Warranties</h2>
                <p>By uploading Source Material, you represent and warrant that:</p>
                <ul>
                    <li>
                        You own the Source Material, or have all necessary rights, licenses,
                        consents, and permissions to upload it and to authorize the Company
                        to process it as described in these Terms;
                    </li>
                    <li>
                        The Source Material does not infringe any third party&rsquo;s
                        intellectual property, privacy, publicity, contractual, or other
                        rights;
                    </li>
                    <li>
                        The Source Material does not contain unlawful, defamatory, obscene,
                        harassing, hateful, or otherwise objectionable content;
                    </li>
                    <li>
                        Any data within the Source Material that identifies third parties
                        has been lawfully obtained and may be processed for the purposes
                        described here.
                    </li>
                </ul>
        <h2 style={{ color: "#4f81bd" }}>License to the Company</h2>
                <p>
                    You grant the Company a worldwide, non-exclusive, royalty-free,
                    sublicensable license to host, store, reproduce, modify, adapt,
                    transcribe, translate, process via AI systems, transmit, and display
                    your Source Material and resulting AI Output
                    <b>
                        for the purpose of operating, providing, securing, and improving the
                        Service
                    </b>{" "}
                    , including delivery of Courses to Students who are entitled to access
                    them.
                </p>
        <h2 style={{ color: "#4f81bd" }}>Prohibited Course Content</h2>
                <p>Creators must not publish Courses that:</p>
                <ul>
                    <li>
                        facilitate the creation of weapons, malware, controlled substances,
                        or other unlawful goods;
                    </li>
                    <li>
                        promote violence, terrorism, child exploitation, hate, or
                        discrimination on protected grounds;
                    </li>
                    <li>
                        constitute regulated professional advice unless the Creator is duly
                        licensed and discloses that fact;
                    </li>
                    <li>
                        infringe copyrights, trademarks, or other rights of third parties;
                        or
                    </li>
                    <li>
                        violate any other rule set out in our published Content Policy.
                    </li>
                </ul>
        <h2 style={{ color: "#4f81bd" }}>Ownership of Courses</h2>
                <p>
                    As between you and the Company, you retain ownership of your Source
                    Material. You also own the published Course
                    <b>
                        to the extent of your original creative contribution and curation
                    </b>{" "}
                    , subject to:
                </p>
                <ul>
                    <li>
                        the Company&rsquo;s rights in the underlying Service, technology, AI
                        systems, templates, and infrastructure;
                    </li>
                    <li>
                        the rights of third parties (including any open-source or stock
                        assets) referenced or incorporated; and
                    </li>
                    <li>
                        the limited license granted to Students under the Student Terms.
                    </li>
                </ul>
                <p>
                    You acknowledge that AI Output, in many jurisdictions, may not be
                    eligible for copyright protection as a standalone work. You are
                    responsible for understanding the legal status of AI-generated
                    material in jurisdictions where you publish.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Student Terms</h1>
        <h2 style={{ color: "#4f81bd" }}>Enrollment</h2>
                <p>
                    By enrolling in a Course, you agree to pay the listed price (if any)
                    and acknowledge the Course description, including any disclosures
                    about AI-generated content.
                </p>
        <h2 style={{ color: "#4f81bd" }}>License to Students</h2>
                <p>
                    Upon successful payment (or enrollment in a free Course), the Company
                    grants you a personal, non-exclusive, non-transferable,
                    non-sublicensable license to access and view the Course for personal,
                    non-commercial learning purposes, for the access period stated at
                    purchase (or, if none is stated, for as long as the Course remains on
                    the Service, subject to these Terms).
                </p>
                <p>You must not:</p>
                <ul>
                    <li>
                        download, copy, screen-record, redistribute, resell, or publicly
                        display the Course (except as expressly permitted by the player);
                    </li>
                    <li>
                        share your account credentials or grant others access to a Course
                        you have purchased;
                    </li>
                    <li>
                        use the Course or its contents to train any machine-learning model
                        or to build a competing product; or
                    </li>
                    <li>
                        circumvent any digital rights management or technical protection
                        measure.
                    </li>
                </ul>
        <h1 style={{ color: "#4f81bd" }}>AI Features (cuGPT)</h1>
                <p>
                    CUbits integrates generative AI functionality through cuGPT, which
                    enables users to generate video summaries, create questions on demand,
                    and receive contextual answers within the scope of video content.
                    These AI features are designed to enhance your learning experience.
                </p>
                <p>
                    By using cuGPT and other AI features, you acknowledge and agree that:
                </p>
                <ul>
                    <li>
                        AI-generated outputs are for educational assistance only and may not
                        be fully accurate
                    </li>
                    <li>
                        You should not rely solely on AI-generated content for academic,
                        professional, or critical decisions
                    </li>
                    <li>
                        CUbits does not guarantee the completeness, accuracy, or fitness for
                        purpose of AI outputs
                    </li>
                    <li>
                        Your interactions with cuGPT may be used to improve the AI system,
                        subject to our Privacy Policy
                    </li>
                    <li>
                        You will not use cuGPT to generate content that violates these Terms
                        or applicable laws
                    </li>
                </ul>
                <p>
                    Our AI curation technology is protected by Princeton University
                    patents granted in 2021 and continues to evolve. We reserve the right
                    to modify or discontinue AI features with reasonable notice.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Third-Party Services</h1>
                <p>
                    The Service may integrate with, link to, or depend on third-party
                    services (including AI model providers, payment processors, hosting,
                    and analytics). Your use of those services may be subject to separate
                    terms. We are not responsible for third-party services and do not
                    endorse them.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Intellectual Property</h1>
                <p>
                    All content on the CUbits platform &mdash; including but not limited
                    to video content, course materials, AI-generated summaries, software,
                    trademarks, logos, and interface design &mdash; is the property of
                    CUbits, Inc.&nbsp;or its licensed content providers, and is protected
                    by applicable intellectual property laws.
                </p>
                <p>
                    You are granted a limited, non-exclusive, non-transferable, revocable
                    license to access and use platform content solely for your personal,
                    non-commercial educational purposes for the duration of your active
                    subscription or free access period.
                </p>
                <p>This license does not permit you to:</p>
                <ul>
                    <li>Reproduce, distribute, or publicly display any content</li>
                    <li>Create derivative works based on platform content</li>
                    <li>
                        Use CUbits trademarks or branding without prior written permission
                    </li>
                    <li>Sublicense or transfer your access rights to any third party</li>
                </ul>
                <p>
                    If you are a content creator contributing to the CUbits marketplace,
                    you retain ownership of your original content but grant CUbits,
                    Inc.&nbsp;a worldwide, royalty-bearing license to host, distribute,
                    translate, and promote your content on the platform in accordance with
                    your creator agreement.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Privacy &amp; Data</h1>
                <p>
                    Your privacy matters to us. Our full
                    <b>Privacy Policy</b> &nbsp;governs the collection, use, and
                    protection of your personal data and is incorporated into these Terms
                    by reference. By using CUbits, you consent to our data practices as
                    described in the Privacy Policy.
                </p>
                <p>
                    For questions about your data or to exercise privacy rights, contact
                    us at support@cubits.ai.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Disclaimers</h1>
                <p>
                    <b>
                        THE CUBITS PLATFORM AND ALL CONTENT, FEATURES, AND SERVICES ARE
                        PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo;
                        BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
                    </b>{" "}
                </p>
                <p>CUbits does not warrant that:</p>
                <ul>
                    <li>
                        The platform will be uninterrupted, error-free, or secure at all
                        times
                    </li>
                    <li>Any errors or defects will be corrected as soon as possible</li>
                    <li>The platform is free of viruses or other harmful components</li>
                    <li>Content is always current, complete, or accurate</li>
                    <li>
                        AI-generated outputs are factually correct or suitable for any
                        specific purpose
                    </li>
                </ul>
                <p>
                    Educational content on CUbits is intended for learning purposes only
                    and does not constitute professional, academic, legal, or career
                    advice. Certifications or credentials displayed by instructors or
                    creators are not independently verified by CUbits unless explicitly
                    stated.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Limitation of Liability</h1>
                <p>
                    <b>
                        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, CUBITS, INC. AND
                        ITS OFFICERS, DIRECTORS, EMPLOYEES, AND AFFILIATES SHALL NOT BE
                        LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
                        PUNITIVE DAMAGES ARISING FROM YOUR USE OF OR INABILITY TO USE THE
                        CUBITS PLATFORM.
                    </b>{" "}
                </p>
                <p>This includes, without limitation, damages for:</p>
                <ul>
                    <li>Loss of data, profits, or revenue</li>
                    <li>Unauthorized access to or alteration of your account</li>
                    <li>Conduct of any third party on the platform</li>
                    <li>Errors or omissions in AI-generated content</li>
                    <li>Service interruptions or technical failures</li>
                </ul>
                <p>
                    In no event shall CUbits&rsquo; total liability exceed the total
                    amount paid by you to CUbits in the twelve (12) months prior to the
                    claim.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Termination</h1>
                <p>
                    You may cancel your account or subscription at any time through your
                    account settings or by contacting us at support@cubits.ai. Upon
                    cancellation of a paid subscription, you will lose access to all
                    subscribed content immediately. No partial refunds are issued for
                    unused time unless required by applicable law.
                </p>
                <p>
                    CUbits reserves the right to suspend or terminate your account at any
                    time, with or without notice, for:
                </p>
                <ul>
                    <li>Violation of these Terms or our policies</li>
                    <li>Fraudulent, abusive, or illegal activity</li>
                    <li>Failure to pay subscription fees</li>
                    <li>
                        Any conduct we determine to be harmful to users or the platform
                    </li>
                </ul>
                <p>
                    Upon termination, your license to use the platform immediately ceases.
                    Provisions of these Terms that by their nature should survive
                    termination shall continue to apply.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Governing Law</h1>
                <p>
                    These Terms are governed by the laws of the State of New Jersey,
                    United States, without regard to conflict of law principles. Any
                    disputes shall be resolved exclusively in the state or federal courts
                    located in New Jersey, and you consent to the personal jurisdiction of
                    those courts.
                </p>
        <h1 style={{ color: "#4f81bd" }}>General</h1>
                <p>
                    <b>Entire Agreement.</b> &nbsp;These Terms, together with any policies
                    referenced (including the Privacy Policy, Content Policy, and Creator
                    Payout Policy), constitute the entire agreement between you and the
                    Company regarding the Service and supersede any prior agreements.
                </p>
                <p>
                    <b>Severability.</b> &nbsp;If any provision is held unenforceable, the
                    remaining provisions remain in full force, and the unenforceable
                    provision will be modified to the minimum extent necessary to make it
                    enforceable while preserving its intent.
                </p>
                <p>
                    <b>No Waiver.</b> &nbsp;A failure to enforce any provision is not a
                    waiver of our right to do so later.
                </p>
                <p>
                    <b>Assignment.</b> &nbsp;You may not assign these Terms without our
                    prior written consent. We may assign these Terms to an affiliate or in
                    connection with a merger, acquisition, or sale of assets.
                </p>
                <p>
                    <b>No Agency.</b> &nbsp;Nothing in these Terms creates a partnership,
                    joint venture, employment, or agency relationship between you and the
                    Company. Creators are independent of the Company.
                </p>
                <p>
                    <b>Force Majeure.</b> &nbsp;Neither party is liable for failure or
                    delay caused by events beyond its reasonable control (including
                    natural disasters, war, civil unrest, strikes, internet or utility
                    outages, or governmental action).
                </p>
                <p>
                    <b>Language.</b> &nbsp;These Terms are written in English. Where
                    translations are provided for convenience, the English version
                    prevails in case of conflict.
                </p>
        <h1 style={{ color: "#4f81bd" }}>Contact Us</h1>
                <p>
                    If you have questions, concerns, or requests related to these Terms
                    and Conditions, please reach out to us:
                </p>
                <p>
                    <b>CUbits, Inc.&nbsp;&mdash; Legal &amp; Support</b> &nbsp;100
                    Overlook Center, 2nd Floor, Princeton, NJ, United States Email:
                    support@cubits.ai Website: www.cubits.ai
                </p>
                <p>
                    For content creator partnership inquiries, please use the same email
                    address and include &ldquo;Creator Partnership&rdquo; in the subject
                    line.
                </p>
                <hr />
                <p></p>
                <p>
                    <i>
                        &copy; 2025&ndash;2026 CUbits, Inc.&nbsp;All rights reserved.
                    </i>{" "}
                </p>
                <p>
                    <i>
                        Version 3 &mdash; Effective June 1, 2026 &mdash; support@cubits.ai
                    </i>{" "}
                </p>
            </div>
        </div>
    );
};

export default TermsAndConditions;
